const RESOURCE_NAME = "entities/contractTypes";

export default {};
